import { FC } from "react";

interface DefaultCardProps {
  title?: string;
  text: string;
  useConditional?: boolean;
  conditional?: boolean;
  conditionalTextTrue?: string;
  conditionalTextFalse?: string;
  className?: string; // This prop is already defined and ready to use
}

const DefaultCard: FC<DefaultCardProps> = ({
  title = "",
  text,
  conditional,
  conditionalTextTrue,
  conditionalTextFalse,
  useConditional,
  className, // Include className here
}) => {
  return (
    // Use a template literal to include `className` dynamically
    <div
      className={
        className
          ? `your-default-classname ${className}`
          : "your-default-classname"
      }
    >
      <div
        // href="#"
        className="block p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100"
      >
        {title && (
          <h5 className="mb-2 text-xl text-left font-semibold tracking-tight text-blue_royal">
            {title}
            {useConditional && conditional ? (
              <span className="text-sm mt-1">{conditionalTextTrue}</span>
            ) : (
              <span className="text-sm mt-1">{conditionalTextFalse}</span>
            )}
          </h5>
        )}
        <p className="font-sans whitespace-pre-line text-left text-gray-700">
          {text}
        </p>
      </div>
    </div>
  );
};

export default DefaultCard;
